import { useBeforeUnload } from 'react-use';

const usePreventUnload = (prevent?: boolean) => {
  useBeforeUnload(
    prevent === undefined ? true : prevent,
    '입력한 정보는 저장되지 않을 수 있습니다.'
  );
};

export default usePreventUnload;
